<template>
  <div class="component-container" :key="sectionInfo.title + '_smr_band'">
    <h2 class="component-title" tabindex="0">{{getTitle(sectionInfo.title)}}</h2>
    <smr-cell-list v-if="cellList && cellList.length"
               :cell-list="cellList"
               :thumbnail-info="thumbnailInfo"
               :container-class-name="getCellListContainerClassName"/>
  </div>
</template>

<script>
import { getBandTypeInfoBySmrCellType } from '@/common/image.util'
import SmrCellList from '@/components/section/template/LoadingBand'
export default {
  name: 'Smr',
  components: {
    SmrCellList
  },
  props: {
    cellList: {
      type: Array
    }
  },
  data () {
    return {
      thumbnailInfo: {}
    }
  },
  methods: {
    getTitle (title) {
      return 'test'
    }
  },
  computed: {
    getCellListContainerClassName () {
      return ''
      // return getCellListContainerClassName(this.thumbnailInfo.type)
    }
  },
  created () {
    this.thumbnailInfo = getBandTypeInfoBySmrCellType(this.sectionInfo.cellType)
  }

}
</script>
